import * as React from "react";
import { Link, RouteComponentProps, useParams } from "@reach/router";
import Icon from "@material-ui/core/Icon";
import { ApolloError, useQuery } from "@apollo/client";
import { ContainerCard } from "components/haven-design";
import {
  DocumentDetails as Query,
  DocumentDetailsVariables as Vars,
} from "types/gql-types";
import { formatUploadDate } from "../utls";
import { documentQuery as query } from "./queries";
import styles from "./styles.module.css";

enum QueryErrors {
  DocumentNotFound = "document_not_found",
  NotAuthorized = "not_authorized",
}

const handleApolloError = (e: ApolloError) => {
  switch (e.message) {
    case QueryErrors.DocumentNotFound:
      return "Invalid document ID";
    case QueryErrors.NotAuthorized:
      return "Not authorized";
    default:
      return `An unknown error occured - ${e.message}`;
  }
};

const Document: React.FC<RouteComponentProps> = () => {
  const params: { id: string } = useParams();
  const { data, loading, error } = useQuery<Query, Vars>(query, { variables: { id: params.id } });

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{handleApolloError(error)}</div>;
  if (!data?.document) return <div>Document failed to load.</div>;
  const { document } = data;

  return (
    <ContainerCard>
      <h1>
        <Link to="/dash/client/documents">My Documents</Link> &gt; {document.category}
      </h1>

      <div className="flex">
        <div>
          <div>
            <a href={document.url} target="_blank" rel="noreferrer">
              {document.name}
            </a>
          </div>
          <div className={styles.timestamp}>{formatUploadDate(document.uploadedAt)}</div>
        </div>
        <a href={document.downloadUrl}>
          <Icon color="primary" className={styles.downloadIcon}>
            download
          </Icon>
        </a>
      </div>
    </ContainerCard>
  );
};

export default Document;
